import React from 'react'
import { get } from 'lodash'
import ErrorMessage from 'components/ErrorMessage'
import { trackTransactionalError } from 'lib/utils/errors'
import getDisplayName from 'lib/get-display-name'

const defaultOptions = {
  path: 'error',
  title: 'Oops'
}

export default (opts = {}) => Component => {
  const componentName = getDisplayName(Component)

  function withError(props) {
    const providedOptions = typeof opts === 'function' ? opts(props) : opts
    const options = Object.assign({}, defaultOptions, providedOptions)
    const hasError = get(props, options.path)

    if (hasError) {
      // Get the filepath for bundle loading errors or the <Route>'s `path` prop
      const path = get(hasError, 'request', '') || get(props, 'route.path', '')
      const title = get(options, 'title')

      trackTransactionalError(componentName, {
        path,
        transactionTitle: title
      })

      return <ErrorMessage {...props} {...options} />
    }

    return <Component {...props} />
  }

  withError.displayName = `withError(${componentName})`
  return withError
}
